<template>
  <div>
    <ClarionDateControl class="input-text-size mt-n2 mb-n2" :isToggle="false"
      v-model="editedItem.certDate" label="Cert Date" :isRequired="true" />
    <v-text-field class="input-text-size pa-0 pt-1" v-model.number="editedItem.certNumber"
      label="Cert Number" type="number" />
    <v-textarea class="input-text-size pa-0 mb-n5" outlined rows="3"
      v-model="editedItem.comments" label="Comments"
      v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';

export default {
  name: 'createAdjTaxDialog',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'createAdjTaxDialog',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      isVisibleAdjPopUp: (state) => state.base.crud.isVisible.createAdjTaxDialog,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
  },
};
</script>
